export default function HearTheBeat() {
  return null;
}